<mat-card-content class="container">
  <mat-card class="card-login">
    <mat-card-header>
      <mat-card-title class="title-custom">ÃREA DE LOGIN</mat-card-title>
    </mat-card-header>

    <form  (ngSubmit)="onSubmit()" #form="ngForm">
      <mat-card-content class="conteudo-login">
      <mat-form-field appearance="outline">
        <mat-label>UsuÃ¡rio</mat-label>
        <input matInput  id="username"  [(ngModel)]="login.username" name="username" required>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Senha</mat-label>
        <input matInput  type="password" [(ngModel)]="login.password" name="password" required>
      </mat-form-field>

      <button mat-raised-button color="primary" type="submit" [disabled]="form.form.invalid">Entrar</button>

      <div class="links" style="margin-top: 15px; margin-bottom: 15px;">
        <a [routerLink]="'/esqueci-minha-senha'" class="text-blue">Esqueceu sua senha?</a> ou
        <a [routerLink]="'/esqueci-meu-usuario'">Esqueceu seu usuÃ¡rio?</a>
      </div>

      <div class="divider"></div>

      <div class="or-login-text">ou faÃ§a login com</div>

      <div class="central-acessos">
        <a [href]="centralLoginUrl" target="_self" rel="noopener noreferrer">
          <img src="assets/img/central-de-acessos.png"
               alt="Login pela Central de Acessos"
               class="central-acessos">
        </a>
      </div>

    </mat-card-content>
  </form>
  </mat-card>
</mat-card-content>
